import helpers from '../util/helpers';
import * as constants from '../util/constants';

// Modules
import bookVenue from './modules/bookVenue';
import bookingWidget from './modules/bookingWidget';
import globalSearch from './modules/globalSearch';
import header from './modules/header';
import headerBook from './modules/headerBook';
import socialFeeds from './modules/socialFeeds';

// Components
import dropdowns from './components/dropdowns';
import modals from './components/modals';
import selects from './components/selects';
import tabs from './components/tabs';

// ACF Blocks
import cardsSlider from './acf-blocks/cardsSlider';
import hero from './acf-blocks/hero';
import hoverCard from './acf-blocks/hoverCard';
import imagesSlider from './acf-blocks/imagesSlider';
import offersResults from './acf-blocks/offersResults';
import offersSlider from './acf-blocks/offersSlider';
import roomsResults from './acf-blocks/roomsResults';
import roomsSlider from './acf-blocks/roomsSlider';
import testimonials from './acf-blocks/testimonials';
import thingsToDoResults from './acf-blocks/thingsToDoResults';
import venuesResults from './acf-blocks/venuesResults';
import venuesSlider from './acf-blocks/venuesSlider';
import contactUs from './acf-blocks/contactUs';
import evtstays from './acf-blocks/evtstays';

export default {
  init() {
    // calculate the scrollbar width then store in css variable
    // this is used for vw not include scrollbar in windows
    // example: width: calc(100vw - var(--scrollbar-width))
    document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + 'px');

    const body = $('body');

    let auth0Settings = {};

    if (window.EVT_Stays_Membership) {
      auth0Settings = window.EVT_Stays_Membership.auth0Settings || {};
    }

    // Login / Join
    const loginJoinModal = $('.login-join-modal');
    if (loginJoinModal.length) {
      const modal = helpers.getParameterByName('modal');
      if (
        modal != null &&
        modal.length &&
        (modal === 'evtstays-login' || modal === 'evtstays-join')
      ) {
        if (modal === 'evtstays-login') {
          body.addClass('login-signup-mode');
          loginJoinModal.addClass('show');
          loginJoinModal.removeClass('switch');
          helpers.stopBodyScrolling(true);
        }

        if (modal === 'evtstays-join') {
          body.addClass('login-signup-mode');
          loginJoinModal.addClass('show');
          loginJoinModal.addClass('switch');
          helpers.stopBodyScrolling(true);
        }
      }

      $(document).on('click', '.login-join-trigger, .login-join-close, .login-trigger, .join-trigger, .trigger-evtstays-login, .trigger-pgr-login, .trigger-evtstays-join, .trigger-pgr-join', function(e) {
        e.preventDefault();
        const _this = $(this);

        if (auth0Settings.isEnabled) {
          if (_this.is('.trigger-evtstays-join, .trigger-pgr-join, .join-trigger')) {
            window.EVT_Stays_Membership.auth0Settings.join();
          } else {
            window.EVT_Stays_Membership.auth0Settings.login();
          }

          return false;
        }

        body.toggleClass('login-signup-mode');
        loginJoinModal.toggleClass('show');

        if (body.hasClass('login-signup-mode')) {
          helpers.stopBodyScrolling(true);
        } else {
          helpers.stopBodyScrolling(false);
        }

        return false;
      });

      const joinModalParam = helpers.getParameterByName('join-modal');
      if (joinModalParam != null && joinModalParam.length && joinModalParam.toLowerCase() === 'true') {
        body.addClass('login-signup-mode');
        loginJoinModal.addClass('show');
        loginJoinModal.addClass('switch');
        helpers.stopBodyScrolling(true);
      }

      $(document).on('click', '.join-trigger, .trigger-evtstays-join, .trigger-pgr-join', function(e) {
        e.preventDefault();
        loginJoinModal.addClass('switch');
        return false;
      });

      $(document).on('click', '.login-trigger, .trigger-evtstays-login, .trigger-pgr-login', function(e) {
        e.preventDefault();
        loginJoinModal.removeClass('switch');
        return false;
      });

      $(document).on('click', '.toggle-cards', function(e) {
        e.preventDefault();
        loginJoinModal.toggleClass('switch');
        return false;
      });

      $(document).on('click', function(e) {
        e.stopPropagation();
        if (body.hasClass('login-signup-mode')) {
          if ($(e.target).hasClass('overlay-wrap')) {
            body.removeClass('login-signup-mode');
            loginJoinModal.removeClass('show');
          }
        }
      });

      $(document).on('keydown', function(e) {
        if (body.hasClass('login-signup-mode')) {
          if (e.key === 'Escape') {
            body.removeClass('login-signup-mode');
            loginJoinModal.removeClass('show');
          }
        }
      });
    }

    // Floating label inputs
    const floatingLabel = $('.floating-label');
    if (floatingLabel.length) {
      floatingLabel.each(function() {
        const _this = $(this);
        const input = _this.find('input, textarea');
        const floatedClass ='floated';

        input.bind('check_val', function () {
          if (input.val() !== '') {
            _this.addClass(floatedClass);
          } else {
            _this.removeClass(floatedClass);
          }
        }).on('focus', function () {
          _this.addClass(floatedClass);
        }).on('blur', function () {
          input.trigger('check_val');
        }).trigger('check_val');
      });
    }

    // CF7 forms
    const contactForm = $('form.wpcf7-form');
    if (contactForm.length) {
      $(document).on('wpcf7mailsent', function() {
        // Clear select2 if submit is success
        const selects = contactForm.find('select.select2');

        selects.each(function() {
          const _this = $(this);

          _this.val(null).trigger('change');
        });
      });
    }

    // Modules
    bookingWidget.init();
    globalSearch.init();
    headerBook.init();

    // Components
    dropdowns.init();
    modals.init();
    selects.init();
    tabs.init();

    // ACF Blocks
    cardsSlider.init();
    hero.init();
    hoverCard.init();
    imagesSlider.init();
    offersSlider.init();
    roomsSlider.init();
    testimonials.init();
    venuesSlider.init();
    contactUs.init();
    evtstays.init();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    // Balance elements
    helpers.onWindowEvents(() => {
      helpers.equalHeightElements($('.balance-elements'), false, 30);
    }, 1, 1, 1, 0);

    $(document).on(constants.EVENT_BALANCE_ELEMENTS, () => {
      helpers.equalHeightElements($('.balance-elements'), false, 30);
    });

    // scroll to element if url has a hash
    helpers.onWindowEvents(() => {
      if (location.hash.length !== 0) {
        const hash = location.hash;

        try {
          if ($(hash).length) {
            $(hash).goToElement(undefined);
          }
        } catch (e) {
          return false;
        }
      }
    }, 0, 1, 0, 0);

    // Modules
    bookVenue.finalize();
    header.finalize();
    socialFeeds.finalize();

    // ACF Blocks
    offersResults.finalize();
    roomsResults.finalize();
    thingsToDoResults.finalize();
    venuesResults.finalize();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js